import React, { Component } from 'react';
import SimpleMDE from "react-simplemde-editor";
import PropTypes from 'prop-types';
import axios from 'axios';
import config from '../../../config';
import { DefaultRenderer } from "steem-content-renderer";
import { Images } from '../../../services/Images';
import withErrorNotification from '../../../hof/withErrorNotification';

const renderer = new DefaultRenderer({
    baseUrl: "https://peakd.com/",
    breaks: true,
    skipSanitization: false,
    allowInsecureScriptTags: false,
    addNofollowToLinks: true,
    doNotShowImages: false,
    ipfsPrefix: "",
    assetsWidth: 640,
    assetsHeight: 480,
    imageProxyFn: (url) => url,
    usertagUrlFn: (account) => "/@" + account,
    hashtagUrlFn: (hashtag) => "/trending/" + hashtag,
    isLinkSafeFn: (url) => true,
});

class TextEditorTwo extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string
    };

    constructor() {
        super();
        this.fileInput = React.createRef();
        this.state = {
            value: "",
            initialized: false,
            editor: null,
            fileInput: ''
        };
    }

    componentWillReceiveProps = (nextProps) => {

        if (!this.state.initialized) {
            const {value} = nextProps;

            if (value) {
                console.log("value", value);
                this.setState({
                    initialized: true,
                    value: value
                })
            }
        }
    }

    handleUploadImage = async (file, onSuccess, onError) => {
        try {
            console.log(file);
            const content = await Images.readFile(file);
            const link = await Images.uploadFile(content);
            return onSuccess(link);
        } catch (error) {
            return onError('Cannot upload this image');
        }
    }

    handlePreviewRender = (postContent) => {
        if (postContent) {
            return renderer.render(postContent)
        } else {
            return ""
        }
    }

    handleChange = value => {
        const {onChange} = this.props;

        if (onChange) {
            onChange(value);
        }

        this.setState({value});
    };

    handleUploadSingleImage = async (file) => {

        this.state.editor.replaceSelection(`![](...uploading ${file.name})`, 'around');
        return withErrorNotification(async () => {
            console.log(file);
            const content = await Images.readFile(file);
            const link = await Images.uploadFile(content);
            this.state.editor.replaceSelection(`![](${link})`);
        })
    }

    openFileDialog = (editor) => {
        this.setState({editor: editor.codemirror, fileInput: ''})
        this.fileInput.current.click();
    }

    render() {

        return (
            <div className="text-editor">
                <input type="file" accept="image/x-png,image/gif,image/jpeg" hidden value={this.state.fileInput}
                       ref={this.fileInput} onChange={(e) => this.handleUploadSingleImage(e.target.files[0])}/>
                <SimpleMDE
                    onChange={this.handleChange}
                    value={this.state.value}
                    spellcheck={true}
                    options={{
                        showIcons: ['code', 'table', 'redo', 'heading', 'undo', 'clean-block', 'horizontal-rule'],
                        autofocus: true,
                        spellChecker: false,
                        disableSpellcheck: true,
                        uploadImage: true,
                        imageUploadFunction: this.handleUploadImage,
                        previewRender: this.handlePreviewRender,
                        previewClass: ['MarkdownViewer', 'Markdown'],
                        toolbar: [
                            'bold', 'italic', 'heading', "|", 'code', 'quote', 'unordered-list', 'ordered-list',
                            'clean-block', "|", 'link', {
                                name: "image",
                                action: this.openFileDialog,
                                className: "fa fa-picture-o",
                                title: "Image",
                            }, 'table', 'horizontal-rule', "|", 'preview', 'side-by-side', 'fullscreen', 'guide', "|",
                            'undo', 'redo']
                    }}
                />

            </div>
        );
    }
}


const renderEditor = (props) => {
    const {input, meta} = props;
    return (
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
            <TextEditorTwo {...input} />
            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
        </div>
    );
};

renderEditor.propTypes = {
    input: PropTypes.shape({
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.string,
    }).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderEditor.defaultProps = {
    meta: null,
};

export default renderEditor;
